import React from 'react';
import styled from 'styled-components';
import { Inspector } from '@bynder/design-system';
import { InspectorSetting } from '../../../constants/guides';
import { WidgetSettings } from './WidgetSettings/WidgetSettings';
import { GuidePageSettings } from './GuideSettings/GuidePageSettings';
import { useInspectorStore } from '../../../stores/inspectorStore';

export const InspectorContainer: React.FC = () => {
  const isInspectorOpen = useInspectorStore(s => s.isInspectorOpen);
  const activeInspectorSetting = useInspectorStore(
    s => s.activeInspectorSetting,
  );

  const renderInspectorSetting = () => {
    switch (activeInspectorSetting) {
      case InspectorSetting.PAGE_VIEW:
      case InspectorSetting.GUIDE_VIEW:
        return <GuidePageSettings />;
      case InspectorSetting.SECTION_VIEW:
      case InspectorSetting.WIDGET_VIEW:
        return <WidgetSettings />;
      default:
        return <GuidePageSettings />;
    }
  };

  return (
    <InspectorWrapper
      $isOpen={isInspectorOpen}
      aria-hidden={isInspectorOpen ? 'false' : 'true'}
    >
      <Inspector>{renderInspectorSetting()}</Inspector>
    </InspectorWrapper>
  );
};

const InspectorWrapper = styled.div<{ $isOpen: boolean }>`
  position: absolute;
  z-index: 98;
  top: 0;
  right: ${props => (props.$isOpen ? '0' : `-${Inspector.styles.width}`)};
  bottom: 0;
  transition: right ${Inspector.styles.transition};
`;
